
import { defineComponent } from "vue";
import swiper from "swiper"
export default defineComponent({
  props: {
    img: {
      type: Array
    },
    index: {
      type: String
    }
  },
  data(){
    return {
      swiper:{},
      show: true
    }
  },
  mounted(){
    this.swiper = new swiper ('.swiper-container-com',{
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
    (this.swiper as any).slideTo(this.index, 0)
  },
  unmounted() {
    (this.swiper as any).destroy();
  },
  methods: {
    close(){
      this.$emit("close")
    }
  }
})
